<script>
// 选择服务商

import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import {getCompany} from "@/helpers/common-service";


export default {
  props: {
    selectedServiceCompany: {
      type: [Number, String],
      default: null
    },
    isInvalid: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      service_company: null,
      companies: [],
    }
  },
  mounted() {
    this.getCompany()
  },
  methods: {
    // 获取服务商
    getCompany() {
      getCompany().then(res => {
        this.companies = res
      })
    },
    // 选择服务商后获取对应服务商下的工程师
    serviceCompanyChange(value) {
      if(value){
        this.$emit('changed', value)
      }
    },
  },
  components: {
    Multiselect,
  },
  watch: {
    selectedServiceCompany: {
      immediate: true,
      handler(val) {
        this.service_company = val
      }
    },
  }
}
</script>
<template>
  <Multiselect class="form-control" :class="isInvalid ? 'is-invalid' : ''" mode="single" v-model="service_company" :close-on-select="true" :searchable="true" :placeholder="$t('menu.business-partner.service-company')"
               :create-option="false" :can-clear="false" :can-deselect="false" value-prop="id" label="name" :disabled="isDisabled" :options="companies" @change="serviceCompanyChange" />
</template>
